<template>
  <div class="navbar navbar-colors">
    <div class="navbar__wrapper">
      <div class="navbar__row">
        <div class="navbar__left">
          <div class="logo">
            <img
              alt="Vue logo"
              class="logo__picture"
              src="../../assets/logo-small.png"
            />
            <div class="navbar-title title">Mangomolo Admin</div>
          </div>
        </div>
        <div class="navbar__right">
          <div class="navbar__block back-link normal-text">
            <a :href="backLink"
              >Back to Clipper <menu-right class="back-icon"
            /></a>
          </div>
        </div>
        <div>
          Scaling
          <span
            :title="statusScaling ? messageScaling : 'No scaling required'"
            class="server-status"
            :class="{ disabled: statusScaling }"
          >
            &#9679;
          </span>
          <button class="logoutBtnStyle" @click="logoutUser">
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuRight from "vue-material-design-icons/MenuRight.vue";
import { logout } from "@/api/auth.js";

import { token } from "@/api/params.js";
import { getWorkerScaling } from "@/api/auth.js";

// @group Admin Page
// Admin page navigation bar
export default {
  name: "AdminNavbar",
  components: {
    MenuRight
  },
  data() {
    return {
      backLink: `/?token=${token}`,
      statusScaling: false,
      messageScaling: ""
    };
  },
  async created() {
    this.checkAllScaling();
    // const resp = await getWorkerScaling();
    // this.statusScaling = resp[0].shouldScale;
    // if (resp[0].shouldScale == false) {
    //   this.$message.error(`Scaling required`);
    // }
  },
  methods: {
    async checkAllScaling() {
      const resp = await getWorkerScaling();
      this.statusScaling = resp.find(e => e.shouldScale === true).shouldScale;
      this.messageScaling = resp.find(e => e.shouldScale === true).message;
    },
    async logoutUser() {
      await logout();
      this.$emit("clearDataToken");
    }
  }
};
</script>

<style scoped>
.navbar {
  height: 100%;
}
.navbar-colors {
  background-color: var(--navbar-bg-color);
  color: var(--navbar-font-color);
}
.navbar__wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 24px;
}
.navbar__row {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.server-status {
  padding-left: 5px;
  padding-bottom: 4px;
  font-size: 1.6rem;
  position: relative;
  color: var(--success-color);
  top: 3px;
}

.server-status.disabled {
  color: var(--error-color);
}
.logoutBtnStyle {
  cursor: pointer;
  height: 30px;
  width: 90px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: default;
}
.logo__picture {
  width: 50px;
  padding-right: 10px;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%) brightness(2);
}

.back-link {
  padding: 5px 0 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color var(--fast-transition),
    color var(--fast-transition);
}
.back-link a {
  display: flex;
  align-items: center;
  /** standard link style erasing */
  background-color: transparent;
  color: inherit;
  text-decoration: none;
}
.back-link:hover {
  background-color: var(--navbar-font-color);
  color: var(--navbar-bg-color);
}
.back-icon {
  /** Used icon is shifted somewhy, so this style fixed it **/
  margin-top: 4px;
}

.navbar__block {
  display: flex;
  align-items: center;
}

.normal-text {
  font-family: var(--sans-font);
  font-size: var(--small-font-sz);
}
</style>
